<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-group"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="success" size="sm"  @click="importExcel()">Importar Clientes</CButton>
          <CButton color="info" size="sm" @click="storeModal()">Nuevo Cliente</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
      >
        <template #rfc="{item}"><td class="w200 text-center">{{item.rfc}}</td></template>
        <template #mobile="{item}"><td class="w200 text-center">{{item.mobile}}</td></template>
        <template #email="{item}"><td class="w300 text-center">{{item.email}}</td></template>
        <template #actions="{item}">
          <td class="table_actions b2">
            <CButton color="warning" size="sm" @click="updateModal(item)"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <CustomerModal ref="customerModal" @store="storeProcess" @update="updateProcess"></CustomerModal>
    <ImportCustomerModal ref="importCustomerModal" @refresh="refreshCustomers"></ImportCustomerModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import CustomerModal from './CustomerModal.vue';
import DeleteModal from '../global/DeleteModal.vue';
import ImportCustomerModal from './ImportCustomerModal.vue'
import ws from '../../services/customers';
import store from '../../store'

export default {
  name: 'CustomersTable',
  components: { CustomerModal, DeleteModal, ImportCustomerModal },
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'rfc', label: 'RFC'},
          {key: 'name', label: 'Nombre'},
          {key: 'mobile', label: 'Celular'},
          {key: 'email', label: 'Correo Electrónico'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: []
    }
  },
  methods: {
    storeModal () {
      this.$refs.customerModal.storeModal();
    },
    importExcel () {
      this.$refs.importCustomerModal.importExcelModal();
    },    
    updateModal (item) {
      this.$refs.customerModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Cliente", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      if(response.type == "success"){
        this.$emit("refresh");
      }

      this.showToast(response.type, response.message);
    },
    async refreshCustomers() {
        this.$emit("refresh");

    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refresh");
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete(id);
      
      if(response.type == "success"){
        this.$emit("refresh");
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
